import { useConditionalBackground } from "@/contexts/useConditionalBackground ";
import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";

// Tenta fechar a aba. Navegadores só permitem fechar abas abertas por script;
// abas abertas por link/QR (comum no mobile) costumam ser bloqueadas — por isso
// mantemos a mensagem e o botão como fallback.
function tryCloseTab() {
  try {
    window.close();
    // Truque que ajuda em alguns navegadores quando a aba não foi aberta por script.
    window.open("", "_self");
    window.close();
  } catch {
    /* fechamento bloqueado pelo navegador — segue exibindo a tela */
  }
}

export default function AuthCorbanConfirmation() {
  const backgroundStyle = useConditionalBackground();

  useEffect(() => {
    // Dá um instante para a tela de sucesso renderizar antes de tentar fechar.
    const timer = setTimeout(tryCloseTab, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      minWidth="100vw"
      minHeight="100vh"
      {...backgroundStyle}
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
      fontFamily="Lexend Deca"
    >
      <VStack
        spacing={6}
        bg="white"
        p={8}
        borderRadius="lg"
        boxShadow="lg"
        width="100%"
        maxWidth="400px"
        align="center"
        color="gray.800"
      >
        <Box bg="green.100" color="green.500" p={4} borderRadius="full">
          <FaCheckCircle size={64} />
        </Box>
        <Heading as="h1" size="xl" textAlign="center" color="primary" fontWeight="bold">
          Validação realizada com sucesso
        </Heading>
        <Text fontSize="md" textAlign="center">
          Você já pode fechar esta aba e voltar para a Granatech — o acesso será
          liberado automaticamente.
        </Text>
        <Button
          colorScheme="green"
          borderRadius="full"
          width="100%"
          onClick={tryCloseTab}
        >
          Fechar aba
        </Button>
      </VStack>
    </Box>
  );
}
